(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pl-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-stock')) {
    customElements.define(
      'pl-stock',
      class extends HTMLElement {
        connectedCallback() {
          this.renderEta();
          this.renderCutoff();
          this.timer = setInterval(() => this.renderCutoff(), 30000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        addWorkingDays(from, days) {
          const date = new Date(from);
          let added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) added += 1;
          }
          return date;
        }

        renderEta() {
          const target = this.querySelector('[data-pl-eta]');
          const min = Number(this.dataset.min);
          const max = Number(this.dataset.max);
          if (!target || !min || !max) return;
          const lang = document.documentElement.lang || 'es';
          const format = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
          const now = new Date();
          const start = this.addWorkingDays(now, min);
          const end = this.addWorkingDays(now, max);
          target.textContent = `${format.format(start)} – ${format.format(end)}`;
        }

        renderCutoff() {
          const line = this.querySelector('[data-pl-cutoff]');
          const left = this.querySelector('[data-pl-left]');
          const hour = Number(this.dataset.cutoff);
          if (!line || !left || !hour) return;
          const now = new Date();
          const day = now.getDay();
          const cutoff = new Date(now);
          cutoff.setHours(hour, 0, 0, 0);
          const open = day !== 0 && day !== 6 && now < cutoff;
          line.hidden = !open;
          if (!open) return;
          const minutes = Math.ceil((cutoff - now) / 60000);
          const h = Math.floor(minutes / 60);
          const m = minutes % 60;
          left.textContent = h > 0 ? `${h} h ${m} min` : `${m} min`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pl-vat-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-vat-note')) {
    customElements.define(
      'pl-vat-note',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.map = JSON.parse(this.querySelector('[data-pl-vat-map]').textContent);
          } catch {
            this.map = {};
          }
          this.abort = new AbortController();
          document.addEventListener('change', this.onChange, { signal: this.abort.signal });
        }

        disconnectedCallback() {
          this.abort?.abort();
        }

        onChange = (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.closest('variant-picker')) return;
          const root = this.closest('.shopify-section') || document;
          if (!root.contains(input)) return;
          const text = this.map[input.dataset.variantId];
          if (text) this.querySelector('[data-pl-vat-gross]').textContent = text;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pl-volume-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-volume-table')) {
    customElements.define(
      'pl-volume-table',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.addEventListener('click', this.onClick, { signal });
          document.addEventListener('change', this.onChange, { signal });
          this.sync();
        }

        disconnectedCallback() {
          this.abort?.abort();
        }

        get root() {
          return this.closest('.shopify-section') || document;
        }

        onClick = (event) => {
          const row = event.target instanceof Element ? event.target.closest('.pl-vt__row') : null;
          if (!row || row.classList.contains('is-unavailable')) return;
          const input = this.root.querySelector(`variant-picker input[data-variant-id="${row.dataset.variantId}"]`);
          if (input && !input.checked) input.click();
          this.highlight(row.dataset.variantId);
        };

        onChange = (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.closest('variant-picker')) return;
          if (!this.root.contains(input)) return;
          if (input.dataset.variantId) this.highlight(input.dataset.variantId);
        };

        sync() {
          const checked = this.root.querySelector('variant-picker input:checked[data-variant-id]');
          if (checked) this.highlight(checked.dataset.variantId);
        }

        highlight(id) {
          for (const row of this.querySelectorAll('.pl-vt__row')) {
            row.classList.toggle('is-selected', row.dataset.variantId === String(id));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
